require('./brokerMyInvestmentsActivos.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @components
const BrokerMyInvestmentsOthersAssetsTable = require('../brokerMyInvestmentsOthersAssetsTable/brokerMyInvestmentsOthersAssetsTable');
const BrokerMyInvestmentsAssetsTable = require('../brokerMyInvestmentsAssetsTable/brokerMyInvestmentsAssetsTable');
const { BrokerMyInvestmentsWrappedAssetsTable } = require('../brokerMyInvestmentsWrappedAssetsTable/brokerMyInvestmentsWrappedAssetsTable');
const BrokerMyInvestmentsAssetsEmptyStates = require('../brokerMyInvestmentsAssetsEmptyStates/brokerMyInvestmentsAssetsEmptyStates');
const BrokerMyInvestmentsFooter = require('../brokerMyInvestmentsFooter/brokerMyInvestmentsFooter');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    TYPE_MERCADO_MONETARIO,
    TYPE_RENTA_FIJA,
    TYPE_RENTA_VARIABLE,
    TYPE_GESTION_ALTERNATIVA,
    TYPE_ACTIVOS_REALES,
    TYPE_OTHERS,
    TYPE_MIXTOS,
    TYPE_ACTIVOS_DIGITALES,
} = require('constants/index');
const { TYPE_ALTERNATIVE_FUNDS } = require('constants/flagBasedFeatures');

class BrokerMyInvestmentsActivos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompleteList: {
                [TYPE_MERCADO_MONETARIO]: false,
                [TYPE_RENTA_FIJA]: false,
                [TYPE_RENTA_VARIABLE]: false,
                [TYPE_GESTION_ALTERNATIVA]: false,
                [TYPE_ACTIVOS_DIGITALES]: false,
                [TYPE_ACTIVOS_REALES]: false,
                [TYPE_OTHERS]: false
            }
        };

        this.handleSeeAllLinkClick = this.handleSeeAllLinkClick.bind(this);
    }

    buildExcludedItemLabel(type, excludedItemsNumber) {
        return formatText(`broker-myInvestments${type}ExcludedItems`, [
                excludedItemsNumber
        ]);
    }

    buildSeeAllLink(type, productList) {
        if (this.state.showCompleteList[type] || productList.size <= 5) {
            return;
        }
        const handler = () => {
            this.handleSeeAllLinkClick(type);
        };
        return (
            <span className="broker-my-investments-tables__see-all-link-container">
                <OKLink modifier="widget" inverse={true} onClick={handler}>
                    <FormattedText value="broker-seeAll" />
                </OKLink>
            </span>
        );
    }

    handleSeeAllLinkClick(type) {
        this.setState(function (prevState) {
            return {
                showCompleteList: Object.assign({}, prevState.showCompleteList, { [type]: true })
            };
        });
    }

    wrapProductTable(type, actives) {
        if (!actives || !actives.get('stocks') || actives.get('stocks').size === 0) {
            if(type === TYPE_MIXTOS || type === TYPE_OTHERS){
                return;
            }else{
                return (
                    <BrokerMyInvestmentsAssetsEmptyStates
                        productType={type}
                        immMyWalletCharts={this.props.immMyWalletCharts}
                        onOpenTraderClick={this.props.onOpenTraderClick}
                        setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                    >
                    </BrokerMyInvestmentsAssetsEmptyStates>
                );
            }
        }

        const { alternativeValueColumnTitle, onOpenTraderClick, immFeatureFlag } = this.props;
        const title = immFeatureFlag.get(TYPE_ALTERNATIVE_FUNDS) && type === TYPE_GESTION_ALTERNATIVA
        ? formatText(`brokerAssetClass-privateEquity`)
        : formatText(`broker-investments${type}TableTitle`);

        const itemsNumber = actives.get('stocks').size;
        const excludedItemsNumber = actives.get('totalExcludedItems');
        const hasExcludedItems = actives.get('hasExcludedItems');
        const earnings = actives.get('earnings');
        const earningsPercentage = actives.get('profitablePercentage');
        const currency = actives.get('currency');
        const totalValue = actives.get('totalValue');
        const productList = actives.get('stocks');
        const capital = actives.get('totalInvestment');

        const seeAllLink = this.buildSeeAllLink(type, productList);
        const excludedItemsLabel = this.buildExcludedItemLabel(type, excludedItemsNumber);

        let table;
        let footer;

        switch (type) {
            case TYPE_OTHERS:
                table = (
                    <BrokerMyInvestmentsOthersAssetsTable
                        immStocks={productList}
                        showCompleteList={this.state.showCompleteList[type]}
                        isContractSection={this.props.isContractSection}
                        onPreSelectOriginInternalTransferFund={this.props.onPreSelectOriginInternalTransferFund}
                        onHandleBuyClick={this.props.onHandleBuyClick}
                        setSellContract={this.props.setSellContract}
                    />
                );
                footer = (
                    <div className="broker-my-investments-tables__link-wrapper clearfix">
                        <div className="pull-right">
                            {seeAllLink}
                        </div>
                    </div>
                );
                break;

            case TYPE_MERCADO_MONETARIO:
            case TYPE_RENTA_VARIABLE:
            case TYPE_RENTA_FIJA:
            case TYPE_GESTION_ALTERNATIVA:
            case TYPE_ACTIVOS_REALES:
            case TYPE_ACTIVOS_DIGITALES:
            case TYPE_MIXTOS:
                table = (
                    <BrokerMyInvestmentsAssetsTable
                        type={type}
                        immStocks={productList}
                        currency={currency}
                        showCompleteList={this.state.showCompleteList[type]}
                        isContractSection={this.props.isContractSection}
                        alternativeValueColumnTitle={alternativeValueColumnTitle}
                        onHandleBuyClick={this.props.onHandleBuyClick}
                        pageName={this.props.pageName}

                    />
                );
                footer = (
                    <div className="broker-my-investments-tables__link-wrapper clearfix">
                        <div className="pull-right">
                            {seeAllLink}
                        </div>
                    </div>
                );
                break;

            default:
                break;
        }

        return (
            <BrokerMyInvestmentsWrappedAssetsTable
                type={type}
                productType={title}
                itemsNumber={itemsNumber}
                currency={currency}
                earnings={earnings}
                earningsPercentage={earningsPercentage}
                total={totalValue}
                capital={capital}
                hasExcludedItems={hasExcludedItems}
                excludedItemsLabel={excludedItemsLabel}
                isContractSection={this.props.isContractSection}
                onOpenTraderClick={onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                pageName={this.props.pageName}

            >
                {table}
                {footer}
            </BrokerMyInvestmentsWrappedAssetsTable>
        );
    }

    render() {
        const {
            isFetchingStocksByType,
            displayMercadoMonetario,
            displayRentaFija,
            displayRentaVariable,
            displayAlternativeInvestment,
            displayActivosDigitales,
            displayActivosReales,
            displayMixtos,
            totalInvestment,
            totalValue,
            totalEarnings,
            totalEarningsPercentage,
            displayFooter,
            immMyWalletCharts,
            immBrokerMyInvestments,
            isFetchingMyInvestment
        } = this.props;
        const mercadoMonetario = immBrokerMyInvestments.getIn(['actives','mercadoMonetario']);
        const rentaFija = immBrokerMyInvestments.getIn(['actives','rentaFija']);
        const rentaVariable = immBrokerMyInvestments.getIn(['actives','rentaVariable']);
        const gestionAlternativa = immBrokerMyInvestments.getIn(['actives','gestionAlternativa']);
        const activosDigitales = immBrokerMyInvestments.getIn(['actives','activosDigitales']);
        const activosReales = immBrokerMyInvestments.getIn(['actives','activosReales']);
        const mixtos = immBrokerMyInvestments.getIn(['actives','mixtos']);
        const others = immBrokerMyInvestments.getIn(['actives','others'])

        let mercadoMonetarioTable;
        let rentaFijaTable;
        let gestionAlternativaTable;
        let rentaVariableTable;
        let activosDigitalesTable;
        let activosRealesTable;
        let mixtosTable;
        let buildOthersTable;
        let footer;

        if (displayMercadoMonetario) {
            mercadoMonetarioTable = this.wrapProductTable(TYPE_MERCADO_MONETARIO, mercadoMonetario);
        }

        if (displayRentaFija) {
            rentaFijaTable = this.wrapProductTable(TYPE_RENTA_FIJA, rentaFija);
        }

        if (displayRentaVariable) {
            rentaVariableTable = this.wrapProductTable(TYPE_RENTA_VARIABLE, rentaVariable);
        }

        if (displayAlternativeInvestment) {
            gestionAlternativaTable = this.wrapProductTable(TYPE_GESTION_ALTERNATIVA, gestionAlternativa);
        }

        if (displayActivosDigitales) {
            activosDigitalesTable = this.wrapProductTable(TYPE_ACTIVOS_DIGITALES, activosDigitales);
        }

        if (displayActivosReales) {
            activosRealesTable = this.wrapProductTable(TYPE_ACTIVOS_REALES, activosReales);
        }

        if(displayMixtos) {
            mixtosTable = this.wrapProductTable(TYPE_MIXTOS, mixtos);
        }

        if(this.props.displayOthers){
            buildOthersTable = this.wrapProductTable(TYPE_OTHERS, others);
        }

        if (displayFooter) {
            const footerCurrency = 'EUR'; // @hardcoded
            footer = (
                <BrokerMyInvestmentsFooter
                    isContractFooter={false}
                    currency={footerCurrency}
                    totalCapital={totalInvestment}
                    totalRentability={totalEarnings}
                    totalRentabilityPercentage={totalEarningsPercentage}
                    totalValue={totalValue}
                    immMyWalletCharts={immMyWalletCharts}
                />
            );
        }

        if (isFetchingStocksByType || isFetchingMyInvestment) {
            return <LoadingSection />;
        } else {
            return (
                <div>
                    <div className="broker-my-investments-tables" style={{ overflowX: 'auto' }}>
                        <div>
                            {mercadoMonetarioTable}
                            {rentaFijaTable}
                            {rentaVariableTable}
                            {gestionAlternativaTable}
                            {activosDigitalesTable}
                            {activosRealesTable}
                            {mixtosTable}
                            {buildOthersTable}
                            {footer}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

BrokerMyInvestmentsActivos.propTypes = {
    alternativeValueColumnTitle: PropTypes.bool,
    displayActivosReales: PropTypes.bool,
    displayActivosDigitales: PropTypes.bool,
    displayFooter: PropTypes.bool,
    displayAlternativeInvestment: PropTypes.bool,
    displayPlans: PropTypes.bool,
    displayMercadoMonetario: PropTypes.bool,
    displayMixtos: PropTypes.bool,
    displayOthers: PropTypes.bool,
    displayRentaFija: PropTypes.bool,
    displayRentaVariable: PropTypes.bool,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immMyWalletCharts: PropTypes.object,
    immStocksByType: PropTypes.object,
    isContractSection: PropTypes.bool,
    isFetchingMyInvestment: PropTypes.bool,
    isFetchingStocksByType: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    onOpenTraderClick: PropTypes.func.isRequired,
    onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setSellContract: PropTypes.func.isRequired,
    startExpanded: PropTypes.bool,
    totalEarnings: PropTypes.number,
    totalEarningsPercentage: PropTypes.number,
    totalInvestment: PropTypes.number,
    totalValue: PropTypes.number,
    pageName: PropTypes.string
};

BrokerMyInvestmentsActivos.defaultProps = {
    immStocksByType: Immutable.Map(),
    isContractSection: false,
    displayMercadoMonetario: true,
    displayWarrants: true,
    displayRentaFija: true,
    displayRentaVariable: true,
    displayAlternativeInvestment: true,
    displayActivosDigitales: true,
    displayActivosReales: true,
    displayMixtos: true,
    alternativeValueColumnTitle: false,
    displayFooter: true,
    displayOthers: true
};

module.exports = BrokerMyInvestmentsActivos;
